module.exports = __webpack_public_path__ + "img/sell_img.9bcb44d8.jpg";